export default {
    title: 'Đấu Đánh Máy',
    common: {
        time: '{minutes}:{seconds}',
        kpmUnit: '{count}kt/p',
        noKill: 'Chưa hạ',
        notEnoughStar: {
            title: 'Không đủ Sao khen thưởng',
            message: 'Bạn cần 1 Sao khen thưởng để bắt đầu Đấu Đánh Máy.',
            confirm: 'Xác nhận',
        },
    },
    index: {
        back: 'Quay lại',
        classroomTitle: '{school} Lớp {grade}/{class_name}',
        header: {
            name: 'Tên',
            phase: 'Phase',
            accuracy: 'Đ.xác',
            time: 'T.gian',
            kpm: 'Tốc độ',
            date: 'Ngày',
        },
        meMark: 'Tôi',
        recentRecord: 'Gần đây',
        myRanking: 'Xếp hạng của tôi',
        empty: 'Chưa có kết quả.',
        startRaid: 'Bắt đầu trận',
        startFailed: 'Không thể bắt đầu trận đấu.',
    },
    inplay: {
        phase: 'Phase {phase}',
        exit: 'Thoát',
        combo: 'Combo',
        transition: {
            phase: 'Phase',
            completed: 'hoàn thành!',
            awakening: 'Boss Phase {phase} đang thức tỉnh...',
            loading: 'Đang tải...',
            skip: 'Bỏ qua',
        },
        nextLabel: 'Tiếp: {next}',
        inputLabel: 'Gửi',
        leaveModal: {
            title: 'Thoát ngay bây giờ?',
            message: 'Nếu thoát bây giờ, trận Đấu Đánh Máy sẽ kết thúc với kết quả hiện tại.<br />Bạn vẫn muốn thoát?',
            no: 'Không',
            yes: 'Có',
        },
        contentError: {
            title: 'Không thể tải nội dung',
            message: 'Vui lòng thử lại sau giây lát.',
            confirm: 'Xác nhận',
        },
    },
    result: {
        gameOver: 'Game Over',
        bestRecord: 'Bạn đã lập kỷ lục mới! Hãy quay lại sảnh để xem xếp hạng.',
        reachedPhase: 'Phase đã đạt',
        defeatedBoss: 'Boss đã hạ',
        defeatedUnit: '',
        lastBoss: 'Boss cuối',
        targetKpmTooltip: 'Tốc độ mục tiêu lớp {grade}: {targetKpm} kt/p',
        ranking: 'Quay lại sảnh',
        retry: 'Bắt đầu lại',
        registered: {
            title: 'Đã được ghi vào bảng xếp hạng lớp!',
            message: 'Phase cao hơn xếp trước; cùng phase thì độ chính xác và tốc độ cao hơn xếp trước.',
        },
        stats: {
            maxCombo: 'Tối đa',
            accuracy: 'Độ chính xác',
            typo: 'Lỗi gõ',
            time: 'Thời gian',
            kpm: 'Tốc độ',
            comboUnit: '{count} combo',
            accuracyUnit: '{count}%',
            typoUnit: '{count} lần',
            kpmUnit: '{count} kt/p',
        },
    },
};
